<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="meetings-header d-flex flex-wrap justify-content-between align-items-start m-2 m-md-4">
            <div class="meetings-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()" aria-label="Go back to Evaluations">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to Evaluations
                </button>
                <div class="d-flex flex-wrap align-items-center gap-2 gap-md-3 mb-2">
                    <h3 class="mb-0 meeting-title">Evaluation Details</h3>
                    <app-status-badge 
                        *ngIf="evaluationDetails"
                        [text]="evaluationDetails.evaluationId || evaluationId"
                        [color]="'purple'"
                        [size]="'medium'">
                    </app-status-badge>
                </div>
                <span class="breadcrumb-section mt-2">
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="meetings-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.EVALUATIONS]" class="meetings-header-title breadcrumb-link">Evaluations <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>{{ evaluationDetails?.evaluationId || evaluationId }}</span>
                </span>
            </div>
            <div class="d-flex align-items-center gap-3 action-buttons-header">
                <button class="btn documents-btn" (click)="openAttachmentsDialog()" aria-label="View Documents">
                    <i class="fas" [ngClass]="isLoadingAttachments ? 'fa-spinner' : 'fa-file-alt'" class="me-2"></i>
                    <ng-container *ngIf="isLoadingAttachments; else documentsText">
                        Fetching documents...
                    </ng-container>
                    <ng-template #documentsText>
                        Documents
                    </ng-template>
                    <span *ngIf="attachments.length > 0" class="badge ms-2">{{ attachments.length }}</span>
                </button>
                <button class="btn action-btn-white" (click)="exportPDF()" aria-label="Export PDF">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2">
                        <path d="M10 13.3333V3.33325" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.66699 9.99992L10.0003 13.3333L13.3337 9.99992" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3.33301 16.6667H16.6663" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Export PDF
                </button>
            </div>
        </div>

        <!-- Main Content - Two Column Layout -->
        <div class="row m-2 m-md-4">
            <fieldset class="content-fieldset mb-4">
            <!-- Left Column -->
            <div class="col-12 col-md-8 mb-4 mb-md-0">
                <!-- Evaluation Overview Card -->
                <fieldset class="content-fieldset mb-4">
                    <legend class="section-legend">Evaluation Overview</legend>
                    <div class="evaluation-overview-content" *ngIf="evaluationDetails">
                        
                        <div class="bid-error-message mb-3" *ngIf="!evaluationDetails && getBidErrorMessage()">
                            <p class="error-message-text">
                                <i class="fas fa-exclamation-circle me-2"></i>
                                {{ getBidErrorMessage() }}
                            </p>
                        </div>
                        <div class="info-grid">
                            <div class="info-column">
                                <div class="info-item mb-3">
                                    <div class="info-label">Evaluation ID:</div>
                                    <div class="info-value">{{ evaluationDetails.evaluationId }}</div>
                                </div>
                                <div class="info-item mb-3">
                                    <div class="info-label">PR:</div>
                                    <div class="info-value tender-id-value">{{ evaluationDetails.prNumber }}</div>
                                </div>
                                <div class="info-item">
                                    <div class="info-label">Evaluation Type:</div>
                                    <div class="info-value">
                                        <app-status-badge 
                                            [text]="evaluationDetails.evaluationType"
                                            [color]="getEvaluationTypeColor(evaluationDetails.evaluationType)"
                                            [size]="'small'">
                                        </app-status-badge>
                                    </div>
                                </div>
                            </div>
                            <div class="info-column">
                                <div class="info-item mb-3">
                                    <div class="info-label">Status:</div>
                                    <div class="info-value">
                                        <app-status-badge 
                                            [text]="evaluationDetails.status"
                                            [color]="getStatusColor(evaluationDetails.status)"
                                            [size]="'small'">
                                        </app-status-badge>
                                    </div>
                                </div>
                                <div class="info-item mb-3">
                                    <div class="info-label">PR Title:</div>
                                    <div class="info-value">{{ evaluationDetails.tenderTitle }}</div>
                                </div>
                                <div class="info-item mb-3" *ngIf="evaluationDetails.assignmentInfo?.assignedEvaluators?.length">
                                    <div class="info-label">Assigned evaluators:</div>
                                    <div class="info-value">
                                        <span *ngFor="let ev of evaluationDetails.assignmentInfo.assignedEvaluators; let last = last">
                                            {{ ev.fullName }}{{ !last ? ', ' : '' }}
                                        </span>
                                    </div>
                                </div>
                                <div class="info-item mb-3" *ngIf="evaluationDetails.assignmentInfo?.submittedDate">
                                    <div class="info-label">Submitted on:</div>
                                    <div class="info-value">{{ evaluationDetails.assignmentInfo.submittedDate | date:'dd/MM/yyyy HH:mm' }}</div>
                                </div>
                                <!-- <div class="info-item">
                                    <div class="info-label">Overall Score:</div>
                                    <div class="info-value">
                                        <app-status-badge 
                                            [text]="evaluationDetails.overallScore.split(' / ')[0]"
                                            [color]="'green'"
                                            [size]="'small'">
                                        </app-status-badge>
                                        <span class="score-total"> / {{ evaluationDetails.overallScore.split(' / ')[1] }}</span>
                                    </div>
                                </div> -->
                            </div>
                        </div>   
                        
                        <hr>
                        <div class="info-grid mt-3" *ngIf="evaluationDetails.recommendation">
                            <div class="info-column">
                                <div class="info-item mb-3">
                                    <div class="info-label">Recommendations by Evaluator:</div>
                                    <div class="info-value tender-id-value">{{ evaluationDetails.recommendation }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <!-- All Received Bids for This Tender Card -->
                <fieldset class="content-fieldset mb-4">
                    <legend class="section-legend">All Received Bids for This Tender</legend>
                    <div class="all-bids-header d-flex justify-content-between align-items-center mb-3">
                        <h5 class="all-bids-title mb-0">All Received Bids for This Tender</h5>
                        <div class="total-bids-count">
                            Total Bids Received: <strong>{{ totalBids }}</strong>
                        </div>
                    </div>
                    <div class="bids-table-container">
                        <app-data-table
                            [data]="this.evaluationDetails?.allBids || []"
                            [columns]="tableColumns"
                            [paginator]="false"
                            (onActionClick)="onTableActionClick($event)">
                        </app-data-table>
                    </div>
                </fieldset>
            </div>

            <!-- Right Column -->
            <div class="col-12 col-md-4">
                <!-- Assigned Evaluators Card -->
                <fieldset class="content-fieldset mb-4" *ngIf="evaluationDetails && evaluationDetails.assignmentInfo && evaluationDetails.assignmentInfo.assignedEvaluators && evaluationDetails.assignmentInfo.assignedEvaluators.length > 0">
                    <legend class="section-legend">Assigned Evaluators</legend>
                    <div class="assigned-evaluators-content">
                        <div class="evaluator-item" *ngFor="let evaluator of evaluationDetails.assignmentInfo.assignedEvaluators">
                            <div class="d-flex align-items-center gap-2">
                                <i class="fas fa-user-circle text-primary"></i>
                                <div class="evaluator-info">
                                    <div class="evaluator-name-en">{{ evaluator.fullName }}</div>
                                    <div class="evaluator-name-ar text-muted" *ngIf="evaluator.nameAr">{{ evaluator.nameAr }}</div>
                                    <div class="evaluator-email text-muted small" *ngIf="evaluator.email">
                                        <i class="fas fa-envelope"></i> {{ evaluator.email }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="content-fieldset mb-4" *ngIf="evaluationDetails?.reviewComments">
                    <legend class="section-legend">Secretary Review</legend>
                    <div class="p-3">
                        <div *ngIf="evaluationDetails?.reviewComments" class="alert alert-warning mb-3">
                            <strong>Change request:</strong> {{ evaluationDetails?.reviewComments }}
                        </div>
                    </div>
                </fieldset>

                <!-- Assignment Information Card -->
                <fieldset class="content-fieldset mb-4">
                    <legend class="section-legend">Assignment Information</legend>
                    <div class="assignment-info-content" *ngIf="evaluationDetails?.assignmentInfo">
                        <div class="info-item mb-3" *ngIf="evaluationDetails?.assignmentInfo?.assignedEvaluators?.length">
                            <div class="info-label d-flex align-items-center gap-2">
                                <i class="fas fa-user-check"></i>
                                <span>Evaluated by:</span>
                            </div>
                            <div class="info-value">
                                <span *ngFor="let ev of evaluationDetails?.assignmentInfo?.assignedEvaluators; let last = last">
                                    {{ ev.fullName }}{{ !last ? ', ' : '' }}
                                </span>
                            </div>
                        </div>
                        <div class="info-item mb-3">
                            <div class="info-label d-flex align-items-center gap-2">
                                <i class="fas fa-calendar-alt"></i>
                                <span>Assigned Date:</span>
                            </div>
                            <div class="info-value">
                                {{ evaluationDetails?.assignmentInfo?.assignedDate | date:'dd/MM/yyyy HH:mm' }}
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-label d-flex align-items-center gap-2">
                                <i class="fas fa-file-alt"></i>
                                <span>Submitted Date:</span>
                            </div>
                            <div class="info-value">
                                {{ evaluationDetails?.assignmentInfo?.submittedDate | date:'dd/MM/yyyy HH:mm' }}
                            </div>
                        </div>
                    </div>
                </fieldset>

                <!-- Evaluation Timeline Card -->
                <fieldset class="content-fieldset">
                    <legend class="section-legend">Evaluation Timeline</legend>
                    <div class="timeline-content" *ngIf="evaluationDetails?.timelineEvents">
                        <div *ngFor="let event of evaluationDetails?.timelineEvents; let i = index" class="timeline-item">
                            <div class="timeline-dot" [style.background-color]="getTimelineDotColor(event.type)"></div>
                            <div class="timeline-content-item">
                                <div class="timeline-title">{{ event.title }}</div>
                                <div class="timeline-date">
                                    {{ event.date | date:'dd/MM/yyyy HH:mm' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            </fieldset>
        </div>
    </div>

    <!-- Documents Dialog -->
    <div class="attachments-dialog-overlay" *ngIf="showAttachmentsDialog" (click)="closeAttachmentsDialog()">
        <div class="attachments-dialog" (click)="$event.stopPropagation()">
            <!-- Header -->
            <div class="dialog-header">
                <div class="header-content">
                    <h3 class="dialog-title">Documents</h3>
                </div>
                <button class="close-btn" (click)="closeAttachmentsDialog()" aria-label="Close">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

            <!-- Content -->
            <div class="dialog-content">
                <div class="attachments-list" *ngIf="attachments.length > 0">
                    <div *ngFor="let attachment of attachments; trackBy: trackByAttachment" class="attachment-item">
                        <div class="attachment-icon">
                            <div class="file-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="48" height="48" rx="8" fill="#F3E8F5"/>
                                    <g transform="translate(10, 10) scale(1.4)">
                                        <path d="M12.4987 1.66675H4.9987C4.55667 1.66675 4.13275 1.84234 3.82019 2.1549C3.50763 2.46746 3.33203 2.89139 3.33203 3.33341V16.6667C3.33203 17.1088 3.50763 17.5327 3.82019 17.8453C4.13275 18.1578 4.55667 18.3334 4.9987 18.3334H14.9987C15.4407 18.3334 15.8646 18.1578 16.1772 17.8453C16.4898 17.5327 16.6654 17.1088 16.6654 16.6667V5.83341L12.4987 1.66675Z" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.668 1.66675V5.00008C11.668 5.44211 11.8436 5.86603 12.1561 6.17859C12.4687 6.49115 12.8926 6.66675 13.3346 6.66675H16.668" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8.33464 7.5H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.3346 10.8333H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.3346 14.1667H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="attachment-info">
                            <div class="attachment-name" [title]="attachment.name">{{ attachment.name }}</div>
                            <div class="attachment-meta">
                                {{ attachment.size }} • Uploaded by {{ attachment.uploadedBy }}
                            </div>
                        </div>
                        <div class="attachment-actions">
                            <button class="btn btn-sm preview-btn" (click)="previewAttachment(attachment)" aria-label="Preview" title="Preview">
                                <i class="fas fa-eye"></i>
                            </button>
                            <button class="btn btn-sm download-btn" (click)="downloadFile(attachment)" aria-label="Download" title="Download">
                                <i class="fas fa-download"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="no-attachments" *ngIf="attachments.length === 0 && !isLoadingAttachments">
                    <p>No attachments available</p>
                </div>
                <div class="loading-attachments" *ngIf="isLoadingAttachments">
                    <p>Loading attachments...</p>
                </div>
            </div>

            <!-- Footer -->
            <div class="dialog-footer">
                <button class="btn close-button" (click)="closeAttachmentsDialog()">Close</button>
            </div>
        </div>
    </div>
</div>

